module.exports = __webpack_public_path__ + "img/gb808.prt.b6af9f05.jpg";